module.exports = __webpack_public_path__ + "img/162018.7d9187c1.jpg";